"use client";

import { IconForwardArrow } from "@repo/assets/images";
import cx from "classnames";
import { useCallback, useState } from "react";
const ToggleSummary = ({
  children,
  title
}) => {
  const [showSummary, setShowSummary] = useState(true);
  const toggleSummary = useCallback(() => {
    setShowSummary(prev => !prev);
  }, []);
  return <div className="bg-miniCart-checkout-bg" data-sentry-component="ToggleSummary" data-sentry-source-file="ToggleSummary.jsx">
      <div className={cx("font-heading text-miniCart-text rtl:font-arabic flex items-center px-3 py-4 text-sm font-medium md:text-2xl")}>
        <span>{title}</span>
        <button onClick={toggleSummary} className="ms-auto md:hidden" aria-label="Toggle Summary" title={title}>
          <IconForwardArrow className={cx("transition-all duration-300", {
          "-rotate-90": showSummary,
          "rotate-90": !showSummary
        })} data-sentry-element="IconForwardArrow" data-sentry-source-file="ToggleSummary.jsx" />
        </button>
      </div>
      <div className={cx("transition-all duration-300", {
      "hidden md:block": !showSummary
    })}>
        {children}
      </div>
    </div>;
};
export default ToggleSummary;